const steps = [
  {
    selector: '[data-tour="service-card"]',
    content: 'The Service Card is home to data configuration and analysis',
  },
  {
    selector: '[data-tour="service-selector"]',
    content: 'Select your map service here',
  },
  {
    selector: '[data-tour="time-navigation"]',
    content: 'Select dates with the time slider',
  },
  {
    selector: '[data-tour="time-backward"]',
    content: 'Step back in time',
  },
  {
    selector: '[data-tour="time-forward"]',
    content: 'Step forward in time',
  },
  {
    selector: '[data-tour="time-slider"]',
    content: 'Drag the time slider to select a date',
  },
]

export default steps
// <div data-tour='service-selector' style={{ display: 'flex'}}>



// WEBPACK FOOTER //
// ./src/tour/steps.js